import { HttpInterceptorFn} from '@angular/common/http';
import {environment} from "../../../environments/environment";

export const prependEndpointInterceptor: HttpInterceptorFn = (req, next) => {
  const reqWithEndpoint = req.clone({
    url: environment.api + req.url,
  });
  return next(reqWithEndpoint);
};
